<template>
	<div>
		<cTable ref="table" :config="config" :fields="fields" :footer="{show:()=>false}"></cTable>
	</div>
</template>

<script>
	import cTable from "@/base/common/index";
	export default {
		components: {
			cTable
		},
		props:{
			list:{
				type:Array,
				default:()=>[]
			}
		},
		watch: {
			list(newValue, oldValue) {
				this.$refs['table'].list = newValue
			}
		},
		data() {
			return {
				config:{
					slot:'div',
					height:300,
					resize:false
				},
				fields:[
					{
						name: () => this.$t('batch_number'),
						key: "batch_number",
						minWidth: 130,
					},
					{
						name: () => this.$t("invoicePCS"),
						key: "quantity",
						minWidth: 130,
					},
					{
						name: () => this.$t("Weight"),
						key: "weight",
						minWidth: 130,
					},
					{
						name: () => this.$t("skuVolume"),
						key: "volume",
						minWidth: 130,
					},
					
				]
			}
		},
		mounted() {
		}
	}
</script>

<style scoped>

</style>